import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { humanizeDuration } from '@phoenix/team-m/dashboard/frontend/shared/humanize';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { RuntimePercentages } from '@phoenix/team-m/dashboard/frontend/util/product/product-batteries.model';

import { RuntimeExtensionBar } from './runtime-extension-bar';

const clockIcon = getDesignSystemIcon('icon-clock-16.svg');

interface BatteryRuntimeExtensionProps {
  maxRuntime: number;
  runtimePercentages: RuntimePercentages;
  runtimeIncrease: number | null;
}

export const BatteryRuntimeExtension: FC<BatteryRuntimeExtensionProps> = ({ maxRuntime, runtimePercentages, runtimeIncrease }) => {
  const { t } = useTranslation();
  const [basePercentage, extendedPercentage] = runtimePercentages;

  return (
    <div className="mx-4 mt-3 grow tablet:max-w-[20rem]">
      <RuntimeExtensionBar
        className="my-2"
        basePercentage={basePercentage}
        extendedPercentage={extendedPercentage}
        runtimeIncrease={runtimeIncrease}
      />
      <div className="my-4 flex items-center gap-2">
        <PhoenixIcon className="h-3 max-w-[12px]" icon={clockIcon} />
        <div className="space-x-1 text-secondary-deep stihl-text-body-sm-reg">
          {t('dashboard_fromTheShop_batteries_card_value_runtime', {
            runtimeValue: humanizeDuration(maxRuntime, { unitDisplay: 'long' }),
          })}
        </div>
      </div>
    </div>
  );
};
